import {
  HashLocationStrategy,
  LocationStrategy,
  registerLocaleData
} from '@angular/common';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { SelectorProductosModule } from '@fenix/selector-productos';
import {
  Marca,
  Portal,
  SharedConstantsModule,
  SharedPipesModule,
  CacheInterceptor,
  SharedServicesModule
} from '@fenix/shared';
import { AppComponent } from './app.component';
import { BienvenidoComponent } from './components/estado-situacion/header/bienvenido.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import esCL from '@angular/common/locales/es-CL';
import { HeaderComponent } from './components/estado-situacion/header/header.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { EstadoSituacionComponent } from './components/estado-situacion/estado-situacion.component';
import { EncryptRSAService } from './services/encrypt-rsa.service';
import { AppRoutingModule } from './app-routing.module';
import { EdicionEstadoSituacionComponent } from './components/estado-situacion/edicion-estado-situacion/edicion-estado-situacion.component';
import { InfoEstadoSituacionComponent } from './components/estado-situacion/info-estado-situacion/info-estado-situacion.component';
import { FormularioComponent } from './components/estado-situacion/formulario/formulario.component';
import { MensajeWarningComponent } from './components/estado-situacion/mensaje-warning/mensaje-warning.component';
import { MensajeClienteExisteComponent } from './components/estado-situacion/mensaje-cliente-existe/mensaje-cliente-existe.component';
import { PreguntasComponent } from './components/estado-situacion/preguntas/preguntas.component';
import { UiKitModule } from '@bch/ui-kit';
import { ReactiveFormsModule } from '@angular/forms';
import { LottieModule } from 'ngx-lottie';
import { MensajeExitosoComponent } from './components/estado-situacion/mensaje-exitoso/mensaje-exitoso.component';
import { FormatearSerialDirective } from './directives/formato-numero-serie.directive';
import { SerialValidador } from './directives/validar-numero-documento.directive';
import { DocumentInformationCardComponent } from './components/estado-situacion/formulario/document-information-card/document-information-card.component';
import { LoadingComponent } from './components/estado-situacion/loading/loading.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { DirectiveEessPublicoModule } from '@fenix/directive-eess-publico';
import { environment } from '../environments/environment';
import { MessageHandlerModule } from '@fenix/message-handler';

registerLocaleData(esCL);
const config = {
  portal: Portal.PUBLICO,
  marca: Marca.BCH
};

const siteKey = environment.siteKey;

@NgModule({
  declarations: [
    AppComponent,
    BienvenidoComponent,
    EstadoSituacionComponent,
    MensajeExitosoComponent,
    FormatearSerialDirective,
    DocumentInformationCardComponent,
    EdicionEstadoSituacionComponent,
    FormularioComponent,
    HeaderComponent,
    InfoEstadoSituacionComponent,
    MensajeWarningComponent,
    MensajeExitosoComponent,
    MensajeClienteExisteComponent,
    PreguntasComponent,
    LoadingComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    DirectiveEessPublicoModule,
    HttpClientModule,
    LottieModule,
    MatCardModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    SelectorProductosModule.forRoot(),
    SharedConstantsModule.forRoot(config),
    SharedPipesModule.forRoot(),
    SharedServicesModule.forRoot(),
    UiKitModule,
    MatProgressBarModule,
    RecaptchaV3Module,
    MessageHandlerModule
  ],
  providers: [
    SerialValidador,
    EncryptRSAService,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: siteKey
    },
    { provide: LOCALE_ID, useValue: 'es-CL' },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}

function initializeApp() {
  return () => {
    config.marca = 0;
  };
}
